import React from 'react';
import { Home, BookOpen, Heart, HandHeart, Phone } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const MobileFooterNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const footerNavItems = [
    { name: 'Home', href: '/', icon: Home },
    { name: 'Sermons', href: '/sermons', icon: BookOpen },
    { name: 'Prayer', href: '/prayer', icon: Heart },
    { name: 'Give', href: '/give', icon: HandHeart },
    { name: 'Contact', href: '/contact', icon: Phone }
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-40"
      data-testid="mobile-footer-nav"
    >
      <div className="grid grid-cols-5 h-16">
        {footerNavItems.map((item) => {
          const IconComponent = item.icon;
          const active = isActive(item.href);

          return (
            <button
              key={item.name}
              onClick={() => navigate(item.href)}
              data-testid={`footer-nav-${item.name.toLowerCase()}`}
              className={`flex flex-col items-center justify-center space-y-1 transition-colors duration-200 ${
                active
                  ? 'text-[#f17b21] bg-[#f17b21]/5'
                  : 'text-gray-600 hover:text-[#f17b21]'
              }`}
            >
              <IconComponent className="w-5 h-5" />
              <span className="text-xs font-medium font-sans">{item.name}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileFooterNav;
